import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import SortableContext from '../../components/DragAndDrop/SortableContext';
import { OnDragEndParams, SortableStrategy } from '../../components/DragAndDrop/dragAndDrop.types';
import useWidth, { BreakpointSizes } from '../../components/Hooks/useWidth';
import { IMedia } from '../../lib/MediasLib';
import MediaCard, { MediaCardOptions } from './MediaCard';
import MediaSortableCard from './MediaSortableCard';

const defaultGridProps: BreakpointSizes = {
  xs: 12,
  sm: 6,
  md: 4,
  lg: 4,
  xl: 4,
};

const useStyles = makeStyles()(() => ({
  mediaCardContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
  },
}));

type MediaListProps = {
  list: IMedia[];
  mainLegend?: string;
  onRemoveClick: (media: IMedia) => void;
  onSortEnd: (params: OnDragEndParams) => void;
  options?: MediaCardOptions;
};

const MediaListContainer = ({ list, mainLegend, options, onSortEnd, ...props }: MediaListProps) => {
  const { classes } = useStyles();
  const { mobileWidth } = useWidth();

  if (options?.disableDrag) {
    return (
      <Grid container spacing={3} wrap={mobileWidth ? 'wrap' : 'nowrap'}>
        {list.map((media: IMedia, index: number) => (
          <Grid
            className={classes.mediaCardContainer}
            id={media.id || String(index)}
            key={media.id}
            size={defaultGridProps}
          >
            <MediaCard
              media={media}
              key={`media-${media?.id || index}`}
              options={options}
              {...props}
            />
          </Grid>
        ))}
        {!mobileWidth && <Grid />}
      </Grid>
    );
  }

  return (
    <SortableContext
      items={list}
      onUpdateItems={() => {
        return;
      }}
      onDragEnd={onSortEnd}
      uniqueIdentifier="id"
      strategy={SortableStrategy.HORIZONTAL}
      OverlayComponent={({ activeIndex }) => {
        return (
          <MediaSortableCard
            mediaId={list[activeIndex]?.id || activeIndex.toString()}
            isDragged
            onRemoveClick={props.onRemoveClick}
            legend={activeIndex === 0 ? mainLegend : undefined}
            media={list[activeIndex]}
          />
        );
      }}
    >
      <Grid container spacing={3} wrap={mobileWidth ? 'wrap' : 'nowrap'}>
        {list.map((media: IMedia, index: number) => (
          <Grid key={media.id} className={classes.mediaCardContainer} size={defaultGridProps}>
            <MediaSortableCard
              mediaId={media?.id || String(index)}
              isDragged={false}
              onRemoveClick={props.onRemoveClick}
              legend={index === 0 ? mainLegend : undefined}
              media={media}
              options={options}
            />
          </Grid>
        ))}
        {!mobileWidth && <Grid />}
      </Grid>
    </SortableContext>
  );
};

export default MediaListContainer;
